module.exports = __webpack_public_path__ + "static/img/pro-1.83a14dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-1.png
// module id = lZd7
// module chunks = 1